<template>
  <div class="input-container" :class="{ 'required-fail': requiredFail }">
    <textarea
      :value="value"
      @input="updateValue($event.target.value)"
      type="textarea"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";

export default {
  name: "InputTypeTextAreaNPV",

  mixins: [inputTypeMixin],
};
</script>



// WEBPACK FOOTER //
// src/components/Npv/Configuration/components/InputTypesNPV/InputTypeTextAreaNPV.vue